
import { RedirectionRule, CanonicalRule } from './types';
import { SEODetector } from './seoDetector';

export class ReportGenerator {
  public static generateRedirectionReport(
    redirections: RedirectionRule[],
    canonicals: CanonicalRule[]
  ): string {
    let report = "=== RAPPORT DE REDIRECTIONS ===\n\n";
    
    report += "REDIRECTIONS ACTIVES:\n";
    redirections.forEach(rule => {
      report += `• ${rule.from} → ${rule.to} (${rule.type}) - ${rule.reason}\n`;
    });

    report += "\nCANONICALISATIONS:\n";
    canonicals.forEach(rule => {
      report += `• ${rule.path} → ${rule.canonical} - ${rule.reason}\n`;
    });

    report += "\nURLs ORPHELINES DÉTECTÉES:\n";
    SEODetector.detectOrphanedUrls().forEach(url => {
      report += `• ${url}\n`;
    });

    report += "\nCONTENU DUPLIQUÉ DÉTECTÉ:\n";
    SEODetector.detectDuplicateContent().forEach(item => {
      report += `• Original: ${item.original}\n`;
      item.duplicates.forEach(dup => {
        report += `  - Dupliqué: ${dup}\n`;
      });
    });

    return report;
  }
}
